import React, { useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { InputLabel } from "@material-ui/core";
import Swal from 'sweetalert2';

import loginImage  from "../assets/login_logo.png";
import axios from "../api";
//cria o contexto
import { createContext } from 'react';

export const AuthContext = createContext();

function redirectToRegister() {
    window.location.replace('/register');
}

function saveTokenToLocalStorage(token) {
    localStorage.setItem('token', token);
}

function getTokenFromLocalStorage() {
    return localStorage.getItem('token');
}

function removeTokenFromLocalStorage() {
    localStorage.removeItem('token');
}

const theme = createTheme();

export default function SignIn() {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

   
    const handleSubmit = async (event) => {
        event.preventDefault(); // Evita o recarregamento da página
        try {
            const { data } = await axios.post('login', { email, password });
            let token = data.access_token;
            saveTokenToLocalStorage(token); // Salva o token no localStorage
            // Redireciona o usuário para a página inicial
            window.location.href = '/home';
        } catch (error) {
            // Verifica se o erro retornado é um erro de autenticação (código 401)
            if (error.response && error.response.status === 401) {
                Swal.fire({
                    icon: "error",
                    title: "Acesso negado!",
                    footer: 'O sistema não identificou seu usuário ou senha, tente novamente ou entre em contato com o administrador de sistemas.'
                });
            } else {
                console.error(error);
            }
        }
    };

     // Função que preenche os campos de e-mail e senha
     const fillForm = () => {
        setEmail('guilherme.viana@gmail.com');
        setPassword('gui@viana123');
    };


    return (
        <div style={{
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            background: 'linear-gradient(to bottom, #001834, #000000)'
        }}>
            <Container component="main" sx={{ height: '80vh', display: 'flex', alignItems: 'center', backgroundColor: '#fff' }}>
                <CssBaseline />
                <img src={loginImage} alt="Login" style={{ width: '50%', height: 'auto' }} />

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        width: '900px',
                        maxWidth: '400px',
                        padding: 2,
                    }}
                >
                    <Avatar sx={{ m: 2, bgcolor: '#001834' }}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Sistema de gerenciamento
                    </Typography>
                    <Grid item xs>
                    <Link to="/register">
                    <Button
                        style={{ marginLeft: 10, textDecoration: 'none' }}
                        onClick={fillForm} // Altera o onClick para preencher os campos
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                    >
                        Test Drive
                    </Button>
                </Link>
                            </Grid>
                    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                        <Grid item xs={5}>
                            <InputLabel style={{ padding: '0.6rem' }}>E-mail</InputLabel>
                            <TextField
                           fullWidth
                           id="outlined-required"
                           placeholder="E-mail"
                           size="small"
                           variant="outlined"
                           value={email} // Adiciona o valor do estado ao TextField
                           onChange={(event) => setEmail(event.target.value)}
                            />
                        </Grid>
                        <InputLabel style={{ padding: '0.6rem' }}>Senha</InputLabel>
                        <TextField
                           fullWidth
                           id="outlined-required"
                           placeholder="Senha"
                           size="small"
                           type="password"
                           autoComplete="current-password"
                           value={password} // Adiciona o valor do estado ao TextField
                           onChange={(event) => setPassword(event.target.value)}
                        />
                        <FormControlLabel
                            control={<Checkbox value="remember" color="primary" />}
                            label="Lembrar de mim"
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}>
                            Entrar
                        </Button>
                        <Grid style={{ display: 'flex', justifyContent: "space-between" }} className={'container'}>
                            <Grid item xs>
                                <Link to="/register" >
                                    <Button style={{ marginRight: 10, textDecoration: 'none' }} fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
                                        Esqueceu a senha
                                    </Button>

                                </Link>
                            </Grid>

                            <Grid item xs>
                                <Link to="/register">
                                    <Button  style={{ marginLeft: 10, textDecoration: 'none' }} onClick={() => redirectToRegister()} fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
                                        Registar
                                    </Button>
                                </Link>
                            </Grid>

                        
                        </Grid>
                    </Box>
                </Box>
            </Container>
        </div>
    );
}
